import { PessoaAcessoFiltrosCriteria, PessoaAcessoFiltrosOptions, RoleNome } from "@workflow/types";
import { PessoaResumoDTO } from "./pessoa";

export interface PessoaAcessoResumoDTO {
  acessosPorDia: { dia: string; pessoas: number }[];
  totalAtivos: number;
  /** Pessoas ativas distintas com acesso registrado hoje — não é acumulado histórico. */
  acessaramHoje: number;
}

export interface PessoaAcessoRowDTO {
  acessadoPor: PessoaResumoDTO;
  dia: string;
  /** `true` quando este é o primeiro acesso registrado dessa pessoa. */
  primeiroAcesso: boolean;
}

export type { PessoaAcessoFiltrosCriteria, PessoaAcessoFiltrosOptions };

export const PERIODOS_RESUMO_ACESSOS = [7, 30, 90] as const;
export type PeriodoResumoAcessos = (typeof PERIODOS_RESUMO_ACESSOS)[number];

/** Quantidade de pessoas ativas por cargo — Painel de usuários. */
export interface PessoaCargoResumoDTO {
  cargo: RoleNome;
  total: number;
  pessoas: string[];
}

/** Pessoa ativa atualmente em férias/ausência — Painel de usuários. */
export interface PessoaFeriasDTO {
  id: number;
  nome: string;
  email: string;
  foto?: string;
}

/** Pessoa ativa com `ultimaInteracao` dentro da janela de "online" — Painel de usuários. */
export type PessoaOnlineDTO = PessoaFeriasDTO;
